<!-- ══ Templates nav-left ══════════════════════════════════════════════════ -->

<!-- 1. Header : bouton retour -->
<ng-template #headerTpl>
  <app-button
    variant="tertiary"
    size="small"
    [label]="'OPERATIONS.BACK_AREA_SITES' | translate"
    [addIconLeft]="true"
    (clicked)="router.navigate(['/area'])">
    <img slot="icon-left" src="assets/icon/new_icon/arrow-left.svg" alt="" aria-hidden="true" />
  </app-button>
</ng-template>

<!-- 2. Search + Blast + Filter -->
<ng-template #searchTpl>
  <div class="flex-row">
    <app-input
      class="site-toolbar__search"
      [placeholder]="'GLOBAL.RECHERCHER' | translate"
      [clearable]="true"
      [ngModel]="searchText()"
      (ngModelChange)="searchText.set($event)">
      <svg slot="icon-left" width="16" height="16">
          <use href="../../../assets/icon/new_icon/search.svg"></use>
      </svg>
    </app-input>
    <app-button variant="primary" color="amarante" label="Blast" [addIconLeft]="true"
      [state]="canCreateBlast() ? 'default' : 'disabled'"
      (clicked)="onCreateBlast()">
      <img slot="icon-left" src="assets/icon/new_icon/add_circle.svg" alt="" />
    </app-button>
    <div class="filter-popup-wrapper" #filterBtn>
      <app-button
        variant="secondary" color="amarante" size="small"
        [addLabel]="false" [addIconLeft]="true"
        (click)="openFilter(filterBtn)"
        [state]="filterOpen() ? 'pressed' : 'default'"
        [class.no-hover]="filterOpen()">
        <img slot="icon-left" src="assets/icon/new_icon/filter.svg" alt="" />
        <img slot="icon-left-active" src="assets/icon/new_icon/filter_active.svg" alt="" />
      </app-button>
      @if (filterOpen()) {
      <app-popup-panel
        [isOpen]="filterOpen()"
        [showHeader]="false"
        size="medium"
        class="popup-panel-position"
        [ngStyle]="{ top: filterPopupPos().top, right: filterPopupPos().right }"
        (closed)="filterOpen.set(false)">
        <div class="popup-tabs">
          <button
            type="button"
            class="popup-tab"
            [class.popup-tab--active]="popupTab() === 'filtrage'"
            (click)="changerVuePopup('filtrage')">
            {{ 'TREEVIEW.FILTRER' | translate }}
          </button>
          <button
            type="button"
            class="popup-tab"
            [class.popup-tab--active]="popupTab() === 'parametres'"
            (click)="changerVuePopup('parametres')">
            {{ 'TREEVIEW.PARAMETRES' | translate }}
          </button>
        </div>
        <app-scrollable>
          @if (popupTab() === 'filtrage') {
            <div class="popup-content popup-content--filter">
              <label class="popup-toggle-row">
                <input
                  type="checkbox"
                  class="popup-toggle-row__input"
                  [ngModel]="pendingActiveProjectsOnly()"
                  (ngModelChange)="pendingActiveProjectsOnly.set($event)" />
                <span class="popup-toggle-row__slider"></span>
                <span class="popup-toggle-row__label">{{ 'TREEVIEW.ACTIVE_PROJECTS' | translate }}</span>
              </label>

              <label class="popup-toggle-row">
                <input
                  type="checkbox"
                  class="popup-toggle-row__input"
                  [ngModel]="pendingActiveBlastsOnly()"
                  (ngModelChange)="pendingActiveBlastsOnly.set($event)" />
                <span class="popup-toggle-row__slider"></span>
                <span class="popup-toggle-row__label">{{ 'OPERATIONS.ACTIVE_BLASTS_ONLY' | translate }}</span>
              </label>

              <div class="settings__field">
                <span class="settings__label">{{ 'TREEVIEW.PROJETS' | translate }}</span>
                <app-select
                  [options]="projectFilterOptions()"
                  [ngModel]="pendingProjects()"
                  (selectionsChange)="onProjectsChange($event)"
                  [multiple]="true"
                  [withCheckboxes]="true"
                  [placeholder]="'OPERATIONS.SELECT_PROJECTS' | translate">
                </app-select>
              </div>

              <div class="settings__field">
                <span class="settings__label">{{ 'GLOBAL.ZONES' | translate }}</span>
                <app-select
                  [options]="zoneFilterOptions()"
                  [ngModel]="pendingZones()"
                  (selectionsChange)="onZonesChange($event)"
                  [multiple]="true"
                  [withCheckboxes]="true"
                  [placeholder]="'OPERATIONS.SELECT_ZONES' | translate">
                </app-select>
              </div>

              <div class="settings__field">
                <span class="settings__label">{{ 'TREEVIEW.TYPES' | translate }}</span>
                <app-select
                  [options]="typeFilterOptions()"
                  [ngModel]="pendingTypes()"
                  (selectionsChange)="onTypesChange($event)"
                  [multiple]="true"
                  [withCheckboxes]="true"
                  [placeholder]="'OPERATIONS.SELECT_TYPES' | translate">
                </app-select>
              </div>

              <div class="settings__field">
                <span class="settings__label">{{ 'TREEVIEW.TYPE_TIR' | translate }}</span>
                <app-select
                  [options]="statusOptions()"
                  [ngModel]="pendingStatus()"
                  (selectionChange)="pendingStatus.set($event.id)">
                </app-select>
              </div>

              <div class="settings__field">
                <span class="settings__label">{{ 'GLOBAL.NIVEAU' | translate }}</span>
                <app-select
                  [options]="levelOptions()"
                  [ngModel]="pendingLevel()"
                  (selectionChange)="pendingLevel.set($event.id)">
                </app-select>
              </div>

              <div class="settings__field">
                <span class="settings__label">{{ 'VIBRATION.START_DATE' | translate }} <span class="popup-required">*</span></span>
                <input
                  class="popup-date-input"
                  type="date"
                  [ngModel]="pendingStartDate()"
                  (ngModelChange)="pendingStartDate.set($event)" />
              </div>

              <div class="settings__field">
                <span class="settings__label">{{ 'VIBRATION.END_DATE' | translate }} <span class="popup-required">*</span></span>
                <input
                  class="popup-date-input"
                  type="date"
                  [ngModel]="pendingEndDate()"
                  (ngModelChange)="pendingEndDate.set($event)" />
              </div>
            </div>
          }

          @if (popupTab() === 'parametres') {
            <div class="grouping-panel">
              <div class="settings__field">
                <span class="settings__label">{{ 'CONFIG.LEVEL_1' | translate }}</span>
                <app-select
                  [options]="optionsL1()"
                  [ngModel]="pendingL1()"
                  (selectionChange)="onL1Change($event)"
                  [placeholder]="'OPERATIONS.SELECT' | translate">
                </app-select>
              </div>
              <div class="settings__field">
                <span class="settings__label">{{ 'CONFIG.LEVEL_2' | translate }}</span>
                <app-select
                  [options]="optionsL2()"
                  [ngModel]="pendingL2()"
                  (selectionChange)="onL2Change($event)"
                  [placeholder]="'TREEVIEW.AUCUN' | translate">
                </app-select>
              </div>
              <div class="settings__field" [class.settings__field--disabled]="level3Disabled()">
                <span class="settings__label">{{ 'CONFIG.LEVEL_3' | translate }}</span>
                <app-select
                  [options]="optionsL3()"
                  [ngModel]="pendingL3()"
                  (selectionChange)="onL3Change($event)"
                  [placeholder]="'TREEVIEW.AUCUN' | translate">
                </app-select>
              </div>
            </div>
          }
        </app-scrollable>

        <div slot="footer" class="popup-footer-actions">
          <app-button
            [label]="'GLOBAL.RESET' | translate"
            variant="secondary"
            color="mint"
            size="small"
            [addIconLeft]="true"
            (clicked)="resetPopup()">
            <img slot="icon-left" src="assets/icon/new_icon/restore.svg" alt="" />
          </app-button>

          <app-button
            [label]="'GLOBAL.APPLY' | translate"
            variant="primary"
            color="mint"
            size="small"
            (clicked)="applyPopup()">
          </app-button>
        </div>

      </app-popup-panel>
      }
    </div>
  </div>
</ng-template>

<!-- 3. Site card -->
<ng-template #siteCardTpl>
  <div
    class="site-card"
    [class.site-card--node-active]="!!navLeft.config().selectedNodeId"
    (click)="onSiteCardClick()">
    <div class="site-card__bar"></div>
    <img class="site-card__icon" src="assets/icon/new_icon/home_black.svg" alt="" />
    <span class="site-card__name">{{ siteNav.siteName() }}</span>
  </div>
</ng-template>

<!-- ══ Templates actions page-bar ══════════════════════════════════════════ -->

<ng-template #pageBarSiteTpl>
  @if (canCreateProject()) {
    <app-button [label]="'GLOBAL.PROJET' | translate" size="small" variant="secondary" color="amarante" [addIconLeft]="true"
      [state]="legacy.ready() ? 'default' : 'disabled'"
      (clicked)="siteActions.openCreateProject()">
      <img slot="icon-left" src="assets/icon/new_icon/add_circle_black.svg" alt="" />
      <img slot="icon-left-active" src="assets/icon/new_icon/add_circle.svg" alt="" />
    </app-button>
  }
  <app-button [label]="'MON_SITE.EXPORTER_DONNEE_ANALYSE' | translate" size="small" variant="secondary" color="amarante" [addIconLeft]="true"
    [state]="siteNav.siteId() ? 'default' : 'disabled'"
    (clicked)="siteActions.exportKpis()">
    <img slot="icon-left" src="assets/icon/export_black.svg" alt="" />
    <img slot="icon-left-active" src="assets/icon/export-white.svg" alt="" />
  </app-button>
  <app-button [label]="'GLOBAL.CREER_RAPPORT' | translate" size="small" variant="primary" color="amarante" [addIconLeft]="true"
    [state]="legacy.ready() ? 'default' : 'disabled'"
    (clicked)="siteActions.openReports()">
    <img slot="icon-left" src="assets/icon/new_icon/report.svg" alt="" />
  </app-button>
  <app-button size="small" variant="tertiary" [addLabel]="false" [addIconLeft]="true"
    [state]="canOpenSiteSettings() ? 'default' : 'disabled'"
    (clicked)="openSiteSettings()" data-attr="site-btn-settings">
    <img slot="icon-left" src="assets/icon/new_icon/settings_black.svg" alt="" />
  </app-button>
</ng-template>

<ng-template #pageBarProjectTpl>
  @if (canCreateProject() && queryParams().projectId) {
    <app-button [label]="'GLOBAL.MODIFIER' | translate" variant="secondary" color="amarante" [addIconLeft]="true"
      [state]="legacy.ready() ? 'default' : 'disabled'"
      (clicked)="siteActions.openModifyProject(queryParams().projectId!)">
      <img slot="icon-left" src="assets/icon/new_icon/edit.svg" alt="" />
    </app-button>
  }
  <app-button variant="tertiary" [addLabel]="false" [addIconLeft]="true"
    [state]="canOpenSiteSettings() ? 'default' : 'disabled'"
    (clicked)="openSiteSettings()" data-attr="site-btn-settings">
    <img slot="icon-left" src="assets/icon/new_icon/settings_black.svg" alt="" />
  </app-button>
</ng-template>

<ng-template #pageBarNodeTpl>
  <app-button variant="tertiary" [addLabel]="false" [addIconLeft]="true"
    [state]="canOpenSiteSettings() ? 'default' : 'disabled'"
    (clicked)="openSiteSettings()" data-attr="site-btn-settings">
    <img slot="icon-left" src="assets/icon/new_icon/settings_black.svg" alt="" />
  </app-button>
</ng-template>

<ng-template #pageBarBlastTpl>
  <app-button [label]="'GLOBAL.CREER_RAPPORT' | translate" variant="primary" color="amarante" [addIconLeft]="true"
    [state]="legacy.ready() ? 'default' : 'disabled'"
    (clicked)="blastActions.openReport(queryParams().blastId!)">
    <img slot="icon-left" src="assets/icon/new_icon/report.svg" alt="" />
  </app-button>
  <app-button variant="tertiary" [addLabel]="false" [addIconLeft]="true"
    [state]="canOpenSiteSettings() ? 'default' : 'disabled'"
    (clicked)="openSiteSettings()" data-attr="site-btn-settings">
    <img slot="icon-left" src="assets/icon/new_icon/settings_black.svg" alt="" />
  </app-button>
</ng-template>

<!-- ══ Contenu principal ════════════════════════════════════════════════════ -->

<div class="page-body">

  <!-- Carte Maps — instance unique, [hidden] selon écran + onglet actif -->
  <div
    class="page-body__map"
    [hidden]="activeScreen() === 'node' || pageBar.config().activeTabId !== 'maps'">
    <app-site-map
      [site]="siteNav.site()"
      [blasts]="siteNav.blasts()"
      [visibleBlastIds]="mapVisibleBlastIds()"
      [focusRequest]="mapFocus()"
      [showDetailsLink]="activeScreen() !== 'blast'"
      (openBlast)="openBlast($event)"
      (selectedBlastChange)="onMapBlastSelectionChange($event)" />
  </div>

  <!-- ── Écran SITE ───────────────────────────────────────────────────────── -->
  @if (activeScreen() === 'site' && pageBar.config().activeTabId === 'dashboard') {
    <app-site-dashboard [siteId]="siteNav.siteId()"></app-site-dashboard>
  }
  @if (activeScreen() === 'site' && pageBar.config().activeTabId === 'planning') {
    <div class="planning">
      <div class="planning__switch" role="tablist">
        @for (view of planningViews; track view.id) {
          <button type="button" role="tab" class="planning__switch-btn"
            [class.planning__switch-btn--active]="planningView() === view.id"
            [attr.aria-selected]="planningView() === view.id"
            [attr.data-attr]="'site-planning-' + view.id"
            (click)="setPlanningView(view.id)">{{ view.label | translate }}</button>
        }
      </div>
      <div class="planning__content">
        @if (planningView() === 'drilling') {
          <app-drill-activity-page />
        } @else {
          <app-delivery-activity-page />
        }
      </div>
    </div>
  }
  @if (activeScreen() === 'site' && pageBar.config().activeTabId === 'files') {
    <app-site-files [siteId]="siteNav.siteId()" [siteName]="siteNav.siteName()" />
  }

  <!-- ── Écran PROJECT ────────────────────────────────────────────────────── -->
  @if (activeScreen() === 'project' && pageBar.config().activeTabId === 'kpi') {
    <app-site-analysis-data [siteId]="siteNav.siteId()" [project]="analysisProject()" />
  }
  @if (activeScreen() === 'project' && pageBar.config().activeTabId === 'files' && queryParams().projectId) {
    <app-site-files [siteId]="siteNav.siteId()" [projectId]="queryParams().projectId" />
  }

  <!-- ── Écran NODE ───────────────────────────────────────────────────────── -->
  @if (activeScreen() === 'node' && pageBar.config().activeTabId === 'kpi') {
    <app-site-analysis-data [siteId]="siteNav.siteId()" [blastIds]="analysisBlastIds()" />
  }

  <app-popup
    [isOpen]="siteActions.exportState() !== 'closed'"
    [title]="'GLOBAL.EXPORT_DONNEES' | translate"
    variant="tertiary"
    color="amarante"
    (closed)="siteActions.exportState.set('closed')">
    <p>
      {{ siteActions.exportState() === 'empty' ? ('GLOBAL.AUCUNE_DONNEE_EXPORT' | translate) : ('GLOBAL.PREPARATION_EXPORT' | translate) }}
    </p>
    @if (siteActions.exportState() === 'empty') {
      <div slot="footer">
        <app-button
          variant="secondary"
          color="amarante"
          [label]="'GLOBAL.FERMER' | translate"
          (clicked)="siteActions.exportState.set('closed')">
        </app-button>
      </div>
    }
  </app-popup>

  <!-- ── Écran BLAST ───────────────────────────────────────────────────────── -->
  @if (activeScreen() === 'blast' && pageBar.config().activeTabId !== 'maps') {
    <app-blast [blastId]="queryParams()!.blastId!" [activeTabId]="pageBar.config().activeTabId" [regionId]="siteNav.regionId()!" />
  }

</div>
